import Footer from './Components/Footer/Footer';
import React, {useState} from 'react';
import NewHeader from './Components/Header/NewHeader';
import InfoErrorSuccessPopup from './Components/Notification/InfoMessegesPopups/InfoErrorSuccessPopup';
import useGetSession from './hooks/useGetSession';
import AppRoutes from './routes/AppRoutes';
import {ToastContainer} from 'react-toastify';
import {Route, Routes} from 'react-router-dom';
import InvoicePDFView from './Components/PDFView/InvoicePDFView';
import ScrollToTop from './Components/ScrollToTop';
import {ErrorBoundaryProvider} from './Components/ErrorBoundary';

const App = () => {
	const [burger, setBurger] = useState(false);
	const {isLoaded, loadType, loadText} = useGetSession();

	if (!isLoaded) {
		return <InfoErrorSuccessPopup type={loadType} text={loadText} />;
	} else {
		return (
			<ErrorBoundaryProvider>
				<div className={burger ? 'wrapper lock' : 'wrapper'}>
					<Routes>
						<Route path="/print_invoice/:id/pdf" element={<InvoicePDFView />} />
					</Routes>
					<ToastContainer />
					<ScrollToTop />
					<NewHeader burger={burger} setBurger={setBurger} />
					<AppRoutes />
					<Footer />
				</div>
			</ErrorBoundaryProvider>
		);
	}
};

export default App;
